import React from "react"
import moment from "moment"
import { capitalize } from "../../../../lib"
import styles from "./MonthSelector.scss"

interface IProps {
  setMonth: (month: number) => void
  setYear: (year: number) => void
  month: number
  year: number
}

const MonthSelector = ({ setMonth, setYear, month, year }: IProps) => {
  const previous = "<"
  const next = ">"

  function subtractMonth() {
    const newMonth = month === 0 ? 11 : month - 1
    setMonth(newMonth)
    if (newMonth === 11) {
      setYear(year - 1)
    }
  }

  function addMonth() {
    const newMonth = month === 11 ? 0 : month + 1
    setMonth(newMonth)
    if (newMonth === 0) {
      setYear(year + 1)
    }
  }

  return (
    <div className={styles.container} id="monthSelector">
      <span id="monthSelectorSpan">
        <button id="monthSelectorButton" onClick={subtractMonth}>{previous}</button>
        <span id="month">
          {`${capitalize(
            moment()
              .month(month)
              .format("MMMM")
          )} ${moment()
            .year(year)
            .format("YYYY")}`}
        </span>
        <button id="monthSelectorButton" onClick={addMonth}>{next}</button>
      </span>
    </div>
  )
}

export default MonthSelector
